import database from './data.js'

import api from '../api/api.js'
/* 地方工具 方便全局获取省份城市城镇 */
const placeUtils = {
	/* 获取省份 */
	getProvinceList(showLoading = true) {
		return new Promise((resolve, reject)=> {
			if(database.local.get('province')) {
				resolve(database.local.get('province'))
			}else {
				api.post('getPlaceInfo',{searchType:1},showLoading).then((res)=>{
					database.local.set('province',res.resultData.provinceAndCityList);
					resolve(res.resultData.provinceAndCityList)
				}).catch((err)=>{
					reject([])
				});
			}
		})
	},
	/* 获取城市 */
	getCity(area_id, showLoading = true) {
		return new Promise((resolve, reject)=> {
			api.post('getPlaceInfo',{searchType:2,province:area_id},showLoading).then((res)=>{
				resolve(res.resultData.provinceAndCityList)
			}).catch((err)=>{
				reject([])
			});
		})
	},
	/* 获取城镇 */
	getTown(area_id, showLoading = true) {
		return new Promise((resolve, reject)=> {
			api.post('getPlaceInfo',{searchType:3,city:area_id},showLoading).then((res)=>{
				resolve(res.resultData.provinceAndCityList)
			}).catch((err)=>{
				reject([])
			});
		})
	}
	
};
export default placeUtils



// WEBPACK FOOTER //
// ./src/utils/place.js